<template>
<transition
    enter-active-class="transition ease-out duration-200"
    enter-from-class="transform opacity-0 scale-75"
    enter-to-class="transform opacity-100 scale-100"
    leave-active-class="transition ease-in duration-75"
    leave-from-class="transform opacity-100 scale-100"
    leave-to-class="transform opacity-0 scale-75"
    @after-leave="$emit('update', false)"
>
    <div v-if="show"
        class="fixed delay-500 text-sm bottom-2 left-5 right-5 bg-yellow-100 text-yellow-700 p-4 rounded-md shadow-md flex items-center justify-between z-50"
    >
        <p class="font-bold">{{__('Our website uses cookies. By continuing we assume your permission to deploy cookies, as detailed in our')}} <a target="_blank" class="hover:underline" :href="route('page.show', 'privacy-policy')" rel="nofollow">{{__('privacy and cookies policy')}}</a>.</p>

        <button
            class="close-cookie-banner bg-yellow-200 hover:bg-yellow-300 transition duration-300 rounded-md p-2"
            @click="createCookie($page.props.appName + '_cookie_consent', 'on', 2000)"
        >
            <span>{{__('Allow cookies')}}</span>
        </button>
    </div>
</transition>
</template>

<script>
import { ref } from '@vue/reactivity';
import { onMounted } from '@vue/runtime-core';

export default {
    emits: ['update'],
    setup(props) {
        const show = ref(false);
        onMounted(() => { show.value = true });
        const dropCookie = ref(true);

        function createCookie(name, value, days) {
            if(dropCookie.value) {
                var date = new Date();
                date.setTime(date.getTime()+(days * 24 * 60 * 60 * 1000));

                document.cookie = name + '=' + value
                    + ';expires=' + date.toUTCString()
                    + ';domain=' + window.location.hostname
                    + ';path=/';

                show.value = false;
            }
        }

        return {
            show,

            createCookie
        }
    }
}
</script>

<style>

</style>
